import { Directive, ElementRef, Input, Renderer2, OnChanges, SimpleChanges } from '@angular/core';
import { RequestStatus } from '../types';
import { ERequestStatusCryptoTextType, ERequestStatusCryptoType, ERequestStatusCryptoWithdrawTextType } from '@app/views/pages/deposit/history/digital-currency-crypto/types/crypto-request-status.type';
import { EDirectDepositStatusType } from '@app/views/pages/deposit/history/transactions-list/modules/direct-deposit-history/types/direct-deposit-status.type';

@Directive({
	selector: '[requestStatusClass]',
	standalone: true,
})
export class RequestStatusClassDirective implements OnChanges {

	@Input() status: RequestStatus | ERequestStatusCryptoType | ERequestStatusCryptoTextType | ERequestStatusCryptoWithdrawTextType | EDirectDepositStatusType;
	@Input() statusType: string = 'request';
	@Input() isNewDesign: boolean = false;
	// 'request' || crypto || cryptoDeposit || cryptoWithdraw || directDeposit

	private readonly allStatusClasses = [
		// old design
		'new', 'processing', 'accepted', 'rejected', 'payment', 'done', 'deleted', 'faild', 'refund', 'paying',
		'sending', 'awating-approval',

		// new design
		'warning', 'blue-light', 'success', 'error', 'indigo', 'gray-blue', 'purple'
	];


	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) { }
	ngOnChanges(changes: SimpleChanges): void {
		if (changes['status'] || changes['statusType'] || changes['isNewDesign']) {
			this.setStatusClass();
		}
	}

	private clearClasses(): void {
		for (const c of this.allStatusClasses) {
			this.renderer.removeClass(this.el.nativeElement, c);
		}
	}


	setStatusClass(): void {
		this.clearClasses();

		let cls: string | undefined;

		if (this.statusType === 'request') cls = this.getClassByType();
		if (this.statusType === 'crypto') cls = this.getClassByTypeCrypto();
		if (this.statusType === 'cryptoDeposit') cls = this.getClassByTypeCryptoText();
		if (this.statusType === 'cryptoWithdraw') cls = this.getClassByTypeCryptoWithdrawText();
		if (this.statusType === 'directDeposit') cls = this.getClassByTypeDirectDepositText();

		if (cls) {
			this.renderer.addClass(this.el.nativeElement, cls);
		}
	}

	getClassByType(): string {
		if (!this.isNewDesign) {
			switch (this.status) {
				case RequestStatus.NEW:
					return 'new';

				case RequestStatus.PROCESSING:
					return 'processing';

				case RequestStatus.ACCEPTED:
					return 'accepted';

				case RequestStatus.REJECTED:
					return 'rejected';

				case RequestStatus.PAYMENT:
					return 'payment';

				case RequestStatus.DONE:
					return 'done';

				case RequestStatus.DELETED:
					return 'deleted';

				case RequestStatus.FAILED:
					return 'faild';

				case RequestStatus.REFUND:
					return 'refund';

				case RequestStatus.Paying:
					return 'payment';
			}
		} else {
			switch (this.status) {
				case RequestStatus.NEW:
					return 'warning';

				case RequestStatus.PROCESSING:
					return 'blue-light';

				case RequestStatus.ACCEPTED:
					return 'success';

				case RequestStatus.REJECTED:
					return 'error';

				case RequestStatus.PAYMENT:
					return 'indigo';

				case RequestStatus.DONE:
					return 'success';

				case RequestStatus.DELETED:
					return 'gray-blue';

				case RequestStatus.FAILED:
					return 'error';

				case RequestStatus.REFUND:
					return 'purple';

				case RequestStatus.Paying:
					return 'indigo';
			}
		}
	}

	getClassByTypeCrypto(): string {
		switch (this.status) {
			case ERequestStatusCryptoType.New:
				return 'new';

			case ERequestStatusCryptoType.AwatingApproval:
				return 'awating-approval';

			case ERequestStatusCryptoType.Broadcast:
				return 'processing';

			case ERequestStatusCryptoType.Processing:
				return 'processing';

			case ERequestStatusCryptoType.Done:
				return 'accepted';

			case ERequestStatusCryptoType.Paying:
				return 'paying';

			case ERequestStatusCryptoType.Pending:
				return 'processing';

			case ERequestStatusCryptoType.Sending:
				return 'sending';

			// if need to red color use rejected
		}
	}

	getClassByTypeCryptoText(): string {
		switch (this.status) {
			case ERequestStatusCryptoTextType.New:
				return 'new';

			case ERequestStatusCryptoTextType.Processing:
				return 'processing';

			case ERequestStatusCryptoTextType.Done:
				return 'accepted';

			case ERequestStatusCryptoTextType.Pending:
				return 'processing';
		}
	}

	getClassByTypeCryptoWithdrawText(): string {
		switch (this.status) {
			case ERequestStatusCryptoWithdrawTextType.New:
				return 'new';

			case ERequestStatusCryptoWithdrawTextType.Processing:
				return 'processing';

			case ERequestStatusCryptoWithdrawTextType.Scheduled:
				return 'processing';

			case ERequestStatusCryptoWithdrawTextType.AwatingApproval:
				return 'awating-approval';

			case ERequestStatusCryptoWithdrawTextType.Canceled:
				return 'rejected';

			case ERequestStatusCryptoWithdrawTextType.Failure:
				return 'rejected';

			case ERequestStatusCryptoWithdrawTextType.Done:
				return 'accepted';

			case ERequestStatusCryptoWithdrawTextType.Exception:
				return 'rejected';
		}
	}


	getClassByTypeDirectDepositText(): string {
		switch (this.status) {
			case EDirectDepositStatusType.Done:
				return 'accepted';

			case EDirectDepositStatusType.Refunded:
				return 'processing';

		}
	}
}
